<div class="head-section" fxLayout="row" [fxFlex]="height" fxLayoutAlign="space-between center">
  <h2 *ngIf="title" class="primary-header coralogix head-section__title">{{title}}</h2>
  <div fxLayout="row" class="unique-content">
    <ng-content select=".custom-content"></ng-content>
    <ng-content select="mat-slide-toggle"></ng-content>
    <ng-content select="button"></ng-content>
  </div>
</div>
